import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { appModernizationDetails } from '../../../../../config';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import { BULK_MAINTENANCE_ERROR_MESSAGES } from './bulk-maintenance-error-messages';
import { SharedAuthService } from '../../../../../shared/shared.auth.service';

@Injectable({
  providedIn: 'root'
})
export class ModelEditService {

  private addRequiredFields = [
    { key: 'Update Type', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.UPDATE_TYPE_EMPTY, nullCheck: true },
    { key: 'Update Type', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.UPDATE_TYPE_INVALID, validCheck: true },
    { key: 'Group_Model', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.GROUP_MODEL_EMPTY, nullCheck: true },
    { key: 'Capability_L0', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.CAPABILITY_L0_EMPTY, nullCheck: true },
    { key: 'Capability_L0_Desc', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.CAPABILITY_L0_DESC_EMPTY, nullCheck: true },
    { key: 'Capability_L1', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.CAPABILITY_L1_EMPTY, nullCheck: true },
    { key: 'Capability_L1_Desc', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.CAPABILITY_L1_DESC_EMPTY, nullCheck: true }
  ];

  private updateRequiredFields = [
    { key: 'Update Type', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.UPDATE_TYPE_EMPTY, nullCheck: true },
    { key: 'Update Type', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.UPDATE_TYPE_INVALID, validCheck: true },
    { key: 'Group_Model', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.GROUP_MODEL_EMPTY, nullCheck: true },
    { key: 'Capability_L0_Id', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.CAPABILITY_L0_ID_EMPTY, nullCheck: true },
    { key: 'Capability_L1_Id', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.CAPABILITY_L1_ID_EMPTY, nullCheck: true },
    { key: 'Capability_L2_Id', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.CAPABILITY_L2_ID_EMPTY, nullCheck: true },
    { key: 'Capability_L3_Id', message: BULK_MAINTENANCE_ERROR_MESSAGES.MODEL_EDIT.CAPABILITY_L3_ID_EMPTY, nullCheck: true }
  ];
  
  private modelEditAllowedUpdateTypes: string[] = ['A', 'U'];
  private apiUrl: string;
  private largeApiUrl: string = environment.LargeapiUrl;

  private config: any;
  userDtls: any;
  constructor(private http: HttpClient, private commonService: CommonService, private sharedAuthService: SharedAuthService,) {
    this.config = appModernizationDetails;
    this.apiUrl = environment.apiUrl;
    const currentUser = sessionStorage.getItem('currentUser') || '';
    this.userDtls = {
      cn: this.sharedAuthService.getMsid(),
      mail: sessionStorage.getItem('loggedInUserEmail') || '',
      givenName: currentUser ? currentUser.trim().split(',')[1].trim() : '',
      sn: currentUser ? currentUser.trim().split(',')[0].trim() : '',
    }
  }

  public validateRecord(excelData: any[]) {
    try {
      const clonedExcelData = excelData.map(el => ({ ...el }));
      this.trimExcelData(clonedExcelData);
      const { uniques, duplicates } = this.validateDuplicatesForModelEdit(clonedExcelData);

      for (const [index, item] of uniques.entries()) {
        const validatedRecord = this.validateModelAndUpdateType(item, index);
        if (!validatedRecord.status) {
          item['Status'] = 'Fail';
          item['Message'] = validatedRecord.message;
        } else {
          item['Status'] = 'Success';
          item['Message'] = '';
        }
      }
      return { uniques, duplicates };
    } catch (error) {
      console.error('Error during record validation:', error);
      throw error; // Rethrow the error after logging it
    }
  }

  public trimExcelData(excelData: any[]) {
    for (const item of excelData) {
      this.commonService.trimObjValues(item);
      this.transformIds(item);
    }
  }

  public transformIds(obj: any) {
    for (const key of Object.keys(obj)) {
      if (key == 'Capability_L0_Id' || key == 'Capability_L1_Id' ||
        key == 'Capability_L2_Id' || key == 'Capability_L3_Id') {
        const item = obj[key];
        obj[key] = item.toUpperCase();
      }
    }
  }

  public validateDuplicatesForModelEdit(excelData: any[]) {
    try {
      if (excelData && excelData.length) {
        //find duplicates records
        const uniqueKeys = this.commonService.getModelEditRequiredHeaders();
        const { uniques, duplicates } = this.commonService.findDuplicatesAndUniqueRecords(excelData, uniqueKeys);
        return { uniques, duplicates };
      } else {
        console.error(BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.ZERO_RECORDS_FOUND);
      }
    } catch (e) {
      console.error(BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.VALIDATION_FAILED_PREFIX, e);
    }
  }

  public validateModelAndUpdateType(ele: any, index: number) {

    let obj = this.commonService.initializeValidationObject();

    // Check if row already has a fail status
    if (ele['Status'] && ele['Status'].toLowerCase() == 'fail') {
      return this.commonService.createErrorObject(index, ele['Message']);
    }
    const fieldsTocheckforNoMapping = ['Capability_L0_Id', 'Capability_L1_Id', 'Capability_L2_Id', 'Capability_L3_Id'];

    // Perform all validations
    let requiredColumns = [];
    if (ele['Update Type'] && ele['Update Type'].toUpperCase() === 'A') {
      requiredColumns = this.addRequiredFields;
    } else {
      requiredColumns = this.updateRequiredFields;
    }

    obj = this.commonService.validateFieldsAndUpdateType(requiredColumns, ele, index, obj, this.modelEditAllowedUpdateTypes);

    obj = this.commonService.noMappingCheck(obj, fieldsTocheckforNoMapping);

    return obj.status === false ? obj : { status: true, index, message: "" };

  }

  public modelEditPreview(body: any): Observable<any> {

    body['userDetails'] = this.userDtls;
    const url = this.largeApiUrl + this.config.routerpath.editModelBulkPreview;
    const headers = new HttpHeaders({
      'Content-Type': ''
    });
    const options = {
      headers: headers
    }
    return this.http.put<any>(url, body, options);
  }

  public submitModelEdit(body: any): Observable<any> {

    body['userDetails'] = this.userDtls;
    const url = this.largeApiUrl + this.config.routerpath.editModelBulkImport;
    const headers = new HttpHeaders({
      'Content-Type': ''
    });
    const options = {
      headers: headers
    }
    return this.http.put<any>(url, body, options);
  }
}